<template>
  <fieldset>
    <p>OBS! Det är ej lämpligt att koppla fler än en integration av denna typ till en profil.</p>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">CreditorId</div>
      </div>
      <input type="text" class="form-control" required v-model="creditorId" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Username</div>
      </div>
      <input type="text" class="form-control" required v-model="username" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Password</div>
      </div>
      <input type="password" class="form-control" required v-model="password" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">
          Använd som förvalt alternativ i checkout
        </div>
      </div>
      <input type="checkbox" class="ml-3 align-self-center" v-model="defaultMode" style="width: 20px; height: 20px">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Fältnamn: Banknamn</div>
      </div>
      <input type="text" class="form-control" required v-model="fieldBankName" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Fältnamn: Clearing</div>
      </div>
      <input type="text" class="form-control" required v-model="fieldClearing" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Fältnamn: Kontonummer</div>
      </div>
      <input type="text" class="form-control" required v-model="fieldAccountNumber" @input="onUpdate">
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const creditorId = ref(null);
const username = ref(null);
const password = ref(null);
const defaultMode = ref(false);
const fieldBankName = ref(null);
const fieldClearing = ref(null);
const fieldAccountNumber = ref(null);
const serializedValue = computed(() => {
  return {
    creditor_id: creditorId.value,
    username: username.value,
    password: password.value,
    default_mode: defaultMode.value,
    field_bank_name: fieldBankName.value,
    field_clearing: fieldClearing.value,
    field_account_number: fieldAccountNumber.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    creditorId.value = modelValue.value.creditor_id;
    username.value = modelValue.value.username;
    password.value = modelValue.value.password;
    defaultMode.value = modelValue.value.default_mode;
    fieldBankName.value = modelValue.value.field_bank_name;
    fieldClearing.value = modelValue.value.field_clearing;
    fieldAccountNumber.value = modelValue.value.field_account_number;
  }
}, {
  immediate: true
});
watch(defaultMode, () => {
  // Using this because of @input was faster than v-model on checkbox
  emit("update:modelValue", serializedValue.value);
});
</script>
